<div class="d-flex flex-column s-menu" [appStoryblok]="_editable">
  <div *ngIf="label" class="menu-label">{{ label }}</div>
  <div class="menu-body d-flex flex-column">
    <ng-container *ngFor="let blok of links">
      <ndc-dynamic
        *ngIf="components && !blok.hidden"
        [ndcDynamicComponent]="components[blok.component]"
        [ndcDynamicInputs]="blok"
      >
      </ndc-dynamic>
    </ng-container>
  </div>
</div>
